import React from 'react'
import SimpleBanner from "../Common/SimpleBanner";
import AboutUs_banner from '../../Assets/home/BannerImage.png'
import GetInTouch from '../../Components/Offers/GetInTouch'
import BookYourService from '../../Components/Common/BookYourService'
import OurProfessionals from '../../Components/Common/OurProfessionals'
import WhatWeProvideHome from '../../Components/Home/WhatWeProvideHome';
const Services = () => {
  return (
    <div className='overflow-hidden'>
      <SimpleBanner
        image={AboutUs_banner}
        name="Services"
        path="Home >> Services"
      />
      <WhatWeProvideHome/>
      <GetInTouch />
      <OurProfessionals />
      <BookYourService />
    </div>
  )
}

export default Services;
